<template>
  <el-row class="text-align-left">
    <el-col :span="24">
      <Header></Header>
      <el-col :xl="22" :lg="22" :offset="1"  class="page-title-vendor">{{pageTitle}} </el-col>
      <el-col :xl="3" :lg="4" :offset="1" class="margin-top margin-bottom">
        <!-- search Assessment -->
        <el-form label-position="top" :model="assessmentResultInfo" ref="searchForm">
          <el-form-item label="Year">
            <el-select v-model="assessmentResultInfo.year" placeholder="PLEASE SELECT">
              <el-option
                v-for="(item, index) in yearListSearch"
                :key="index"
                :label="item.yearName"
                :value="item.yearValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Vendor Code">
            <el-input v-model="assessmentResultInfo.vendorCode"></el-input>
          </el-form-item>
          <el-form-item label="Vendor Name">
            <el-input v-model="assessmentResultInfo.vendorName"></el-input>
          </el-form-item>
          <el-form-item prop="email" label="Vendor Email"
                        :rules="[{ type: 'email', message: incorrectEmailMsg, trigger: ['blur', 'change'] }]">
            <el-input v-model="assessmentResultInfo.email" onKeypress="if(event.keyCode == 32) event.returnValue = false"></el-input>
          </el-form-item>
          <el-form-item label="Region">
              <el-select v-model="assessmentResultInfo.region" placeholder="PLEASE SELECT" >
                <el-option
                  v-for="(item, index) in regionListSearch"
                  :key="index"
                  :label="item.regionName"
                  :value="item.regionValue">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="Associated Staff">
            <el-autocomplete popper-class="my-autocomplete" v-model="assessmentResultInfo.applicant" :fetch-suggestions="querySearch" v-if="isVendorOrAdmin">
              <template slot-scope="{ item }">
                <div class="name">{{ item.value}}</div>
              </template>
            </el-autocomplete>
            <el-input v-model="assessmentResultInfo.applicant" v-else disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="Company">
              <el-select v-model="assessmentResultInfo.company" placeholder="PLEASE SELECT" >
                <el-option
                  v-for="(item, index) in companyListSearch"
                  :key="index"
                  :label="item.companyName"
                  :value="item.companyValue">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="Status">
              <el-select v-model="assessmentResultInfo.status" placeholder="PLEASE SELECT" >
                <el-option
                  v-for="(item, index) in statusObjects"
                  :key="index"
                  :label="item"
                  :value="index">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="Score"  v-if="this.isVendorOrAdmin">
            <el-col :span="7">
              <el-input style="width: 73px" v-model="assessmentResultInfo.fromScore"></el-input>
            </el-col>
            <el-col :span="6" style="text-align: center">---</el-col>
            <el-col :span="2">
              <el-input style="width: 73px" v-model="assessmentResultInfo.toScore"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="Grade" placeholder="PLEASE SELECT">
            <el-select v-model="assessmentResultInfo.grade" >
              <el-option
                v-for="(item, index) in gradeObjects"
                :key="index"
                :label="item"
                :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button type="danger" class="search-btn" @click="handleSearchAssessmentResult">{{buttonSearch}}</el-button>
      </el-col>
      <el-col :xl="1" :lg="1" class="margin-top">
        <div class="line"></div>
      </el-col>
      <!-- Export excel -->
      <el-col :xl="18" :lg="17" class="margin-top">
        <el-button v-if="isVendorOrAdmin" @click="exportDialogVisible = true">Report</el-button>
        <el-button @click="exportTableData">{{buttonExport}}</el-button>
        <el-table class="assessmentTable-table"
                  empty-text="No Data"
                  id="assessmentResult"
                  :data="dataSource"
                  :default-sort="{prop: 'year', order: 'descending'}"
                  ref="multipleTable"
                  v-loading="loadingStatus"
                  stripe
                  max-height="700"
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  highlight-current-row
                  @sort-change="handleSortChange">
          <el-table-column type="selection" >
          </el-table-column>
          <el-table-column label="Year" width="100px" align="center" prop="year" sortable>
            <template slot-scope="scope">
              <span>{{scope.row.year}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Assessment Name" width="180px" align="center" sortable prop="assessmentNo">
            <template slot-scope="scope">
              <span @click="gotoResultDetail(scope.row.answerAssessmentId, scope.row.assessmentId,scope.row.applicant)"><a href="javascript:void(0)">{{scope.row.assessmentNo}}</a></span>
            </template>
          </el-table-column>
          <el-table-column label="Vendor Code" width="150px" align="center" sortable prop="vendorCode">
            <template slot-scope="scope">
              <span>{{scope.row.vendorCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Vendor Name" width="150px" align="center" sortable prop="userName">
            <template slot-scope="scope">
              <span>{{scope.row.userName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Vendor Email" width="150px" align="center" sortable prop="vendorEmail">
            <template slot-scope="scope">
              <span>{{scope.row.email}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Region" width="100px" align="center" sortable prop="region">
            <template slot-scope="scope">
              <span>{{scope.row.region}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Associated Staff" width="180px" align="center" sortable prop="applicant">
            <template slot-scope="scope">
              <span>{{scope.row.applicant}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Company" align="center" width="150px" sortable prop="company">
            <template slot-scope="scope">
              <span>{{scope.row.company}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Status" width="100px" align="center" sortable prop="status">
            <template slot-scope="scope">
              <span>{{scope.row.status}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Score" width="100px" align="center" sortable="custom" prop="score" v-if="isVendorOrAdmin">
            <template slot-scope="scope" >
              <span>{{scope.row.score}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Grade" width="100px" align="center" sortable prop="grade">
            <template slot-scope="scope">
              <span>{{scope.row.grade}}</span>
            </template>
          </el-table-column>
          <el-table-column label="Re-do" width="101px" align="center" v-if="this.isVendorOrAdmin">
            <template slot-scope="scope">
              <span v-if="scope.row.status=='COMPLETED'&&scope.row.versionNo<1"><el-button @click="handleRedo(scope.row.answerVendorId,scope.row.versionNo)">Re-do</el-button></span>
            </template>
          </el-table-column>
          <el-table-column label="History" width="100px" v-if="this.isVendorOrAdmin">
            <template slot-scope="scope">
              <span v-if="scope.row.versionNo>0" @click="gotoResultDetail(scope.row.answerAssessmentId, scope.row.assessmentId,scope.row.applicant,scope.row.versionNo)"><a href="javascript:void(0)">Detail</a></span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="table-nav"
                       background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-sizes="[20,40, 100, 200, 500]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="totalCount">
        </el-pagination>
        <el-dialog title="Export Vendor Assessment Report" :visible.sync="exportDialogVisible" width="30%" center>
          <span>Please select the year for the report.</span>
          <div style="margin-top: 15px;">
            <el-select v-model="exportYear" placeholder="Please select">
              <el-option v-for="(item, index) in exportYearObject" :key="index" :label="item" :value="index"></el-option>
            </el-select>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" slot="trigger" size="small" plain @click="exportDialogVisible = false">Cancel</el-button>
            <el-button type="danger" slot="trigger" size="small" plain @click="generateExcelForUser">Export</el-button>
          </span>
        </el-dialog>
      </el-col>
    </el-col>
    <Footer v-on:init="init"></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue'
import { findVendorAssessmentResultByConditions, findAssessmentResultByConditions, callResendEmail, findSearchConditions, saveVersionNoPlusOne, generateExcel } from '@/services/answerer/assessment.service'
import { findDicValue } from '@/services/dictionary.service'
import Constant from '@/common/Constant';
import { verifyUserInfo } from '@/services/login.service'

export default {
  components: {
    Footer,
    Header
  },
  data () {
    return {
      dataSource: [],
      assessmentResultInfo: {
        year: '',
        email: '',
        applicant: '',
        vendorCode: '',
        vendorName: '',
        company: '',
        region: '',
        status: '',
        fromScore: '',
        toScore: '',
        userType: Constant.TYPE_VENDOR,
        currentPage: 1,
        pageSize: 20,
        grade: '',
        isVendorOrAdmin: this.isVendorOrAdmin
      },
      rules: {
        email: [
          { required: true, message: Constant.INPUT_EMAIL, trigger: 'blur' },
          { type: 'email', message: Constant.ENTER_CORRECT_EMAIL, trigger: ['blur', 'change'] }
        ]
      },
      incorrectEmailMsg: Constant.ENTER_CORRECT_EMAIL,
      yearListSearch: [],
      companyListSearch: [],
      regionListSearch: [],
      statusObjects: {},
      gradeObjects: {},
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      multipleSelection: [],
      buttonExport: '',
      buttonSearch: '',
      buttonResend: '',
      pageTitle: '',
      loadingStatus: false,
      isVendorOrAdmin: false,
      displayNames: [],
      scoreObjects: [],
      userRole: '',
      exportSearchConditions: {
        year: '',
        email: '',
        applicant: '',
        vendorCode: '',
        vendorName: '',
        company: '',
        region: '',
        status: '',
        fromScore: '',
        toScore: '',
        grade: ''
      },
      exportDialogVisible: false,
      exportYear: '',
      exportYearObject: {}
    }
  },
  methods: {
    handleSortChange (val) {
      if (val.prop === 'score') {
        if (val.order === 'ascending') {
          this.dataSource = this.dataSource.sort(function (a, b) {
            return a.score - b.score;
          });
        } else if (val.order === 'descending') {
          this.dataSource = this.dataSource.sort(function (a, b) {
            return b.score - a.score;
          });
        }
      }
    },
    gotoResultDetail (answerAssessmentId, assessmentId, applicant, versionNo) {
      let Base64 = require('js-base64').Base64;
      let queryObject = {};
      if (versionNo !== '' && versionNo > 0) {
        queryObject = {userType: Constant.TYPE_VENDOR,
          assessmentId: assessmentId,
          answerAssessmentId: answerAssessmentId,
          name: Base64.encode(applicant),
          versionNo: versionNo}
      } else {
        queryObject = {userType: Constant.TYPE_VENDOR,
          assessmentId: assessmentId,
          answerAssessmentId: answerAssessmentId,
          name: Base64.encode(applicant)}
      }
      let {href} = this.$router.resolve({name: 'QuestionnaireResultDetail',
        query: queryObject});
      window.open(href, '_blank');
    },
    async findAssessmentResult () {
      let searchConditions = await findSearchConditions();
      this.initSearchCondition(searchConditions.data);
      this.$loading({fullscreen: true}).close();
    },
    initSearchCondition (data) {
      let statusSet = new Set();
      let yearSet = new Set();
      let regionSet = new Set();
      let companySet = new Set();
      data.regions.forEach(item => {
        if (item !== '' && item !== null) {
          regionSet.add(item);
        }
      });
      data.companies.forEach(item => {
        if (item !== '' && item !== null) {
          companySet.add(item);
        }
      });
      data.year.forEach(item => {
        if (item !== '' && item !== null) {
          yearSet.add(item);
        }
      });
      statusSet.add(Constant.ANSWER_STATUS_COMPLETED);
      statusSet.add(Constant.ANSWER_STATUS_INPROGRESS);
      statusSet.add(Constant.ANSWER_STATUS_SENT);
      // region dropdown
      let tempRegionObjects = {};
      regionSet.forEach(it => {
        tempRegionObjects[it] = it;
      });
      let regionForAll = {
        regionValue: '',
        regionName: '<ALL>'
      };
      this.regionListSearch.push(regionForAll);
      Object.keys(tempRegionObjects).sort().forEach(item => {
        let region = {
          regionValue: item,
          regionName: item
        };
        this.regionListSearch.push(region);
      });
      // company dropdown
      let tempCompanyObjects = {};
      companySet.forEach(it => {
        tempCompanyObjects[it] = it;
      });
      let companyForAll = {
        companyValue: '',
        companyName: '<ALL>'
      };
      this.companyListSearch.push(companyForAll);
      Object.keys(tempCompanyObjects).sort().forEach(item => {
        let company = {
          companyValue: item,
          companyName: item
        };
        this.companyListSearch.push(company);
      });
      // status dropdown
      let tempStatusObjects = {};
      statusSet.forEach(it => {
        tempStatusObjects[it] = it;
      });
      this.statusObjects[''] = '<ALL>';
      Object.keys(tempStatusObjects).sort().forEach(item => {
        this.statusObjects[item] = item;
      });
      // year dropdown
      let tempYearObjects = {};
      yearSet.forEach(it => {
        tempYearObjects[it] = it;
      });
      let yearForAll = {
        yearValue: '',
        yearName: '<ALL>'
      };
      this.yearListSearch.push(yearForAll);
      Object.keys(tempYearObjects).sort().forEach(item => {
        let year = {
          yearValue: item,
          yearName: item
        };
        this.yearListSearch.push(year);
        this.exportYearObject[item] = item;
        // to get the last value
        this.exportYear = item;
      });
      this.gradeObjects[''] = '<ALL>';
      for (let i = 0; i < this.scoreObjects.length; i++) {
        this.gradeObjects[this.scoreObjects[i].key] = this.scoreObjects[i].key;
      }
    },
    handleSearchAssessmentResult () {
      Object.assign(this.exportSearchConditions, this.assessmentResultInfo)
      this.pageSize = 20;
      this.currentPage = 1;
      this.assessmentResultInfo.pageSize = 20;
      this.assessmentResultInfo.currentPage = 1;
      this.$refs.searchForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          sessionStorage.setItem(Constant.ASSESSMENT_SEARCH_CONDITIONS, JSON.stringify(this.assessmentResultInfo));
          this.callSearchAssessmentResult();
        }
      });
    },
    async callSearchAssessmentResult () {
      this.loadingStatus = true;
      let assessmentResultDto = JSON.parse(sessionStorage.getItem(Constant.ASSESSMENT_SEARCH_CONDITIONS));
      if (assessmentResultDto.grade != null) {
        for (let i = 0; i < this.scoreObjects.length; i++) {
          if (this.scoreObjects[i].key === assessmentResultDto.grade) {
            assessmentResultDto.fromScore = this.scoreObjects[i].down;
            assessmentResultDto.toScore = this.scoreObjects[i].up;
          }
        }
      }
      let resultData = [];
      resultData = await findAssessmentResultByConditions(assessmentResultDto);
      this.dataSource = resultData.data.assessmentResultVos;
      this.totalCount = resultData.data.totalCount;
      this.loadingStatus = false;
    },
    handleResend () {
      if (this.multipleSelection.length === 0) {
        this.$alert(Constant.NO_SELECTED);
      } else {
        this.ResendEmail();
      }
    },
    async ResendEmail () {
      this.$loading({fullscreen: true});
      let answerAssessmentIds = [];
      this.multipleSelection.forEach(it => {
        // answerAssessmentIds = it.answerAssessmentId;
        answerAssessmentIds.push(it.answerAssessmentId)
      });
      let resendInfo = await callResendEmail(answerAssessmentIds);
      if (resendInfo.code !== Constant.POPUP_EXCEPTION_CODE) {
        this.$message(Constant.RESEND_SUCCESSFULLY);
        this.callSearchAssessmentResult();
        this.$loading({fullscreen: true}).close();
      } else {
        this.$alert(resendInfo.msg, 'Warning', {
          confirmButtonText: 'OK'
        });
      }
      this.$loading({fullscreen: true}).close();
    },
    handleSizeChange (val) {
      this.pageSize = val;
      this.assessmentResultInfo = JSON.parse(sessionStorage.getItem(Constant.ASSESSMENT_SEARCH_CONDITIONS));
      this.assessmentResultInfo.pageSize = val;
      sessionStorage.setItem(Constant.ASSESSMENT_SEARCH_CONDITIONS, JSON.stringify(this.assessmentResultInfo));
      this.callSearchAssessmentResult();
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.assessmentResultInfo = JSON.parse(sessionStorage.getItem(Constant.ASSESSMENT_SEARCH_CONDITIONS));
      this.assessmentResultInfo.currentPage = val;
      sessionStorage.setItem(Constant.ASSESSMENT_SEARCH_CONDITIONS, JSON.stringify(this.assessmentResultInfo));
      this.callSearchAssessmentResult();
    },
    handleSelectionChange (value) {
      this.multipleSelection = value;
    },
    init () {
      this.buttonExport = this.$store.state.dictionary[1].BUTTON_EXPORT;
      this.buttonSearch = this.$store.state.dictionary[1].BUTTON_SEARCH;
      this.buttonResend = this.$store.state.dictionary[1].BUTTON_RESEND;
      this.pageTitle = this.$store.state.dictionary[1].RESULT_ASSESSMENT_TITLE;
    },
    async exportTableData () {
      this.$loading({fullscreen: true});
      let assessmentResultDto = this.exportSearchConditions;
      if (assessmentResultDto.grade != null) {
        for (let i = 0; i < this.scoreObjects.length; i++) {
          if (this.scoreObjects[i].key === assessmentResultDto.grade) {
            assessmentResultDto.fromScore = this.scoreObjects[i].down;
            assessmentResultDto.toScore = this.scoreObjects[i].up;
          }
        }
      }
      let dataSource = await findVendorAssessmentResultByConditions(assessmentResultDto);
      require.ensure([], () => {
        const { exportJsonToExcel } = require('@/utils/Export2Excel');
        let tHeader;
        let filterVal;
        if (this.isVendorOrAdmin) {
          tHeader = ['Year', 'Assessment Name', 'Vendor Code', 'Vendor Name', 'Vendor Email', 'Region', 'Associated Staff', 'Company', 'Status', 'Score', 'Grade'];
          filterVal = ['year', 'assessmentNo', 'vendorCode', 'userName', 'email', 'region', 'applicant', 'company', 'status', 'score', 'grade'];
        } else {
          tHeader = ['Year', 'Assessment Name', 'Vendor Code', 'Vendor Name', 'Vendor Email', 'Region', 'Associated Staff', 'Company', 'Status', 'Grade'];
          filterVal = ['year', 'assessmentNo', 'vendorCode', 'userName', 'email', 'region', 'applicant', 'company', 'status', 'grade'];
        }
        let list = dataSource.data;
        list = list.reverse();
        let data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, 'VendorAssessmentResult');
      });
      this.$loading({fullscreen: true}).close();
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    querySearch (queryString, cb) {
      var displayNames = this.displayNames;
      var results = queryString ? displayNames.filter(this.createFilter(queryString)) : displayNames;
      cb(results);
    },
    createFilter (queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    async loadAllDisplayNames () {
      let alldisplaynameslist = await findSearchConditions();
      let displaynameslist = alldisplaynameslist.data.displaynames;
      var arr = []
      for (let i in displaynameslist) {
        let o = {};
        o['value'] = displaynameslist[i];
        arr.push(o);
      }
      return arr;
    },
    async loadScores () {
      let scores = await findDicValue(Constant.CONFIG_BUSINESS, Constant.ASSESSMENT_ANSWER_GRADE_SCOPE);
      let score = scores.data[0].dictValue.split('|');
      let scoreObj = [{}];
      for (let i = 0; i < score.length; i++) {
        scoreObj.push(score[i]);
      }
      let arr = [];
      for (let i = 1; i < scoreObj.length; i++) {
        let temp = scoreObj[i].split(':');
        let tempValue = temp[1].split('_');
        if (tempValue.length === 2 && i !== scoreObj.length) {
          let tempObj = {
            'down': tempValue[0],
            'up': tempValue[1],
            'key': temp[0]
          }
          arr[i - 1] = tempObj;
        }
      }
      this.scoreObjects = arr;
    },
    async loadUserRole () {
      let user = await verifyUserInfo();
      this.userRole = user.role;
    },
    async handleRedo (id, verNo) {
      this.$loading({fullscreen: true});
      let answerVendor = {'answerVendorId': id, 'versionNo': verNo};
      let saveInfo = await saveVersionNoPlusOne(answerVendor);

      if (saveInfo.code === Constant.RESPONSE_SUCCESS_CODE) {
        this.$message.success(Constant.REDO_SUCCESS);
      }

      // display by search condition after redo done
      sessionStorage.setItem(Constant.ASSESSMENT_SEARCH_CONDITIONS, JSON.stringify(this.assessmentResultInfo));
      this.findAssessmentResult().then(value => {
        this.callSearchAssessmentResult();
      });
      this.$loading({fullscreen: true}).close();
    },
    async generateExcelForUser () {
      let content = this.$store.state.dictionary[1].REMIND_STAKEHOLDER_CONFIRM;
      let response = await generateExcel(this.exportYear);
      if (response.msg === null && response.code === 'SUCCESS') {
        this.$alert(content, {
          confirmButtonText: 'OK'
        });
      }
      this.exportDialogVisible = false;
    }
  },
  mounted () {
    this.$loading({fullscreen: true});
    sessionStorage.setItem(Constant.ASSESSMENT_SEARCH_CONDITIONS, JSON.stringify(this.assessmentResultInfo));
    this.loadScores();
    this.loadUserRole().then(value => {
      if (this.userRole === Constant.USER_TYPE_ADMIN || this.userRole === Constant.USER_TYPE_VENDOR) {
        this.isVendorOrAdmin = true;
      }
    });
    this.loadAllDisplayNames().then(result => {
      this.displayNames = result;
      if (!this.isVendorOrAdmin) {
        this.assessmentResultInfo.applicant = this.displayNames[0].value;
      }
    });
    this.findAssessmentResult().then(value => {
      this.callSearchAssessmentResult();
    });
  },
  beforeDestroy () {
    this.$loading({fullscreen: true}).close();
  }
};
</script>

<style scoped>
  .text-align-left {
    text-align: left;
  }

  .page-title-vendor{
    font-size: 20px;
    margin-top: 80px;
  }
  .margin-top{
    margin-top: 30px;
  }
  .margin-bottom{
    margin-bottom: 45px;
  }
  .line {
    width: 1px;
    height: 700px;
    background-color: #e6e6e6;
    margin-left: 20px;
  }

  .assessmentTable-table{
    margin-top: 15px;
  }

  .table-nav{
    position: fixed;
    bottom: 40px;
  }

  .search-btn{
    margin-top: 20px;
    width: 200px;
  }

  .dialog-form .el-input{
    width: 360px;
  }
  /*rewrite element-ui */

  >>>.el-button{
    border-color: #5e89ed;
    color: #5e89ed;
  }

  >>>.el-button:hover{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button:focus{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger{
    background-color: #5e89ed;
    border-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger:hover{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-button--danger:focus{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-table{
    color: black;
  }

  >>>.el-table thead{
    color: black;
  }

  >>>.el-form--label-top .el-form-item__label{
    padding: 0;
  }

  >>>.el-form-item{
    margin-bottom: 5px;
  }

  >>>.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #5e89ed;
    border-color: #5e89ed;
  }

  >>>.el-pager li.active{
    color: #5e89ed;
  }

  >>>.el-pager li:hover{
    color: #5e89ed;
  }

  >>>.el-checkbox__inner{
    border: 1px solid #aaaaaa;
  }

  >>>.el-form-item__label{
    line-height: 32px;
  }

  >>>.el-table .cell{
    word-break:keep-all;
  }
  >>>a:hover {
    color: #5e89ed;
  }
  /*>>>.el-button--primary {*/
    /*color: #fff;*/
  /*}*/
</style>
<style>
  .el-input{
    margin-top: 0;
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/VendorAssessmentResult.vue